import { createSlice } from "@reduxjs/toolkit";

export const weekOfYearSlice = createSlice({
    name: 'weekofyear',
    initialState: {
        start: undefined,
        end: undefined
    },
    reducers: {
        setStartWeek: (state, action) => {
            state.start = action.payload;
        },
        setEndWeek: (state, action) => {
            state.end = action.payload;
        },
        setWeekOfYear: (state, action) => {
            state.start = action.payload.start
            state.end = action.payload.end
        }
    }
})

export const { setStartWeek, setEndWeek, setWeekOfYear } = weekOfYearSlice.actions;

export const getWeekOfYear = (state) => state.weekofyear;

export default weekOfYearSlice.reducer;